export default "__VITE_ASSET__QAEfKyAW__"